import React from 'react';
import type { ListBlock as ListBlockType } from '../../../types';
import renderTextWithVariables from '../renderTextWithVariables';

const ListBlock: React.FC<{ block: ListBlockType }> = ({ block }) => {
    const Tag = block.ordered ? 'ol' : 'ul';
    return (
        <Tag style={{ margin: '0.8rem 0', paddingLeft: '2rem' }}>
            {block.items.map((item, i) => (
                <li key={i}>{renderTextWithVariables(item)}</li>
            ))}
        </Tag>
    );
};
export default ListBlock;
